
import { computed, defineComponent, reactive } from 'vue';
import ServicoAgendamento from '@/servicos/MeuSistema/ServicoAgendamento';
import { IOptionString } from '@/core/models/AntDesign/IOption';

export default defineComponent({
  name: 'SelecionarMarcador',
  props: {
    marcadoresSelecionados: {
      type: Array as () => string[],
      default: () => [],
    },
    codigoUsuario: {
      type: Number,
      default: 0,
    },
    todosUsuarios: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:marcadoresSelecionados'],
  setup(props, { emit }) {
    let debounce = 0;
    const servicoAgendamento = new ServicoAgendamento();

    const state = reactive({
      listaMarcadores: [] as IOptionString[],
    });

    const computedMarcadoresSelecionados = computed({
      get: () => props.marcadoresSelecionados,
      set: (valor: string[]) => {
        emit('update:marcadoresSelecionados', valor);
      },
    });

    async function pesquisarMarcador(valorPesquisa: any) {
      state.listaMarcadores = [];
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        const marcadoresApi = await servicoAgendamento.consultarMarcadores(props.codigoUsuario, props.todosUsuarios, valorPesquisa);
        marcadoresApi.forEach((marcador) => {
          const optionMarcador:IOptionString = { value: marcador, label: marcador };
          state.listaMarcadores.push(optionMarcador);
        });
      }, 600);
    }

    return {
      props,
      state,
      pesquisarMarcador,
      computedMarcadoresSelecionados,
    };
  },
});
